import React from "react";

const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to perform this action?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "delete", // 'delete', 'warning', 'info'
}) => {
  if (!isOpen) return null;

  const getColors = () => {
    switch (type) {
      case "delete":
        return {
          confirmBg: "bg-red-600 hover:bg-red-700",
          icon: (
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          ),
        };
      case "warning":
        return {
          confirmBg: "bg-yellow-600 hover:bg-yellow-700",
          icon: (
            <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          ),
        };
      default:
        return {
          confirmBg: "bg-primary-600 hover:bg-primary-700",
          icon: (
            <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        };
    }
  };

  const colors = getColors();

  return (
    <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-[60] p-4" style={{ backgroundColor: 'rgba(18, 76, 114, 0.2)' }}>
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md" style={{ borderColor: 'rgba(18, 76, 114, 0.1)', borderWidth: '1px' }}>
        {/* Modal Header */}
        <div className="flex items-center justify-center p-6 border-b rounded-t-2xl" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          background: 'linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)'
        }}>
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-opacity-20" style={{ 
            backgroundColor: type === 'delete' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(18, 76, 114, 0.1)' 
          }}>
            {colors.icon}
          </div>
        </div>

        {/* Modal Body */}
        <div className="p-6 text-center">
          <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(18, 76, 114)' }}>
            {title}
          </h3>
          <p className="text-gray-600 mb-6">
            {message}
          </p>
        </div>

        {/* Modal Footer */}
        <div className="flex flex-col sm:flex-row justify-center gap-3 p-6 border-t rounded-b-2xl" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
        }}>
          <button
            onClick={onClose}
            className="px-5 py-2.5 bg-white border rounded-lg transition-all font-medium flex-1"
            style={{ 
              color: 'rgb(18, 76, 114)',
              borderColor: 'rgba(18, 76, 114, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'white';
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`px-5 py-2.5 text-white font-medium rounded-lg transition-all flex-1 ${colors.confirmBg}`}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;